import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Style.css"
import React from 'react'

const ImageSlider = ({images}) => {

const settings = {
	infinite: true,
	dots: false,
	slidesToShow: 1,
	slidesToScroll: 1,
	fadeIn : true,
	autoplay: true,
autoplaySpeed: 3000,

};
return (
	<>
	
	<div className="imgslider">
		<Slider {...settings}>
		{images.map((item) => (
			<div key={item.id}>
			<img src={item.src} alt={item.alt} />
			</div>
		))}
		</Slider>
	</div>
		</>
)
}
export default ImageSlider;
